import React, { useState } from 'react';
import moment from 'moment';
import { Redirect } from 'react-router-dom';
import { redirectPath } from '../config/config';
import { isLoggedIn } from '../config/token';
import LoginForm from '../components/Login/LoginForm';

const Login = () => {
  const [successLogIn, setLoginSuccess] = useState(false);
  if (isLoggedIn() || successLogIn) return <Redirect to={redirectPath} />;

  return <LoginForm setLoginSuccess={setLoginSuccess} />;
};

export default Login;